import axios from "axios"
// import { useSelector } from "react-redux"
import { store } from "../store"
import { CREATE_DESTINOS_ERROR, CREATE_DESTINOS_LOADING, CREATE_DESTINOS_SUCCESS, DELETE_DESTINOS_ERROR, DELETE_DESTINOS_LOADING, DELETE_DESTINOS_SUCCESS, GET_DESTINOS_ERROR, GET_DESTINOS_LOADING, GET_DESTINOS_SUCCESS, UPDATE_DESTINOS_ERROR, UPDATE_DESTINOS_LOADING, UPDATE_DESTINOS_SUCCESS } from "./destino_types"
import { BASE_URL } from "../../constants/config"
import { LOGOUT } from "../users/user_types"

import {toast, Toaster } from 'react-hot-toast';


export const getDestinos = ()=>async(dispatch)=>{
    const {token} = store.getState().userReducer
    dispatch({type: GET_DESTINOS_LOADING})
    try {
        
        //console.log(" Inicio getDestinos " );

        const res = await axios(BASE_URL+"/destino", {
            method: "get",
            headers: {
                Authorization: token
            }
        })                

        const {status, message, data} = res.data
        /*console.log(" RES Destino "+status+" => ",res.data);
        console.log(" RES Destino 2 "+status+" => ",datadestino);*/
        if(status === 1){
                
                dispatch({type: GET_DESTINOS_SUCCESS, payload: data})
        }else if(status === 2)
        dispatch({type: LOGOUT})
        else { toast.error(" Error cargando Destinos. "+message)
                dispatch({type: GET_DESTINOS_ERROR})
        }
    } catch (error) {
        toast.error("Error en la conexión");
        dispatch({type: GET_DESTINOS_ERROR})
    }
}

export const createDestinos = (obj)=>async(dispatch)=>{
    
    
    const {token} = store.getState().userReducer
    dispatch({type: CREATE_DESTINOS_LOADING})
    try {
        
        const res = await axios(BASE_URL+"/destino/create", {
            method: "post",
            data: obj,
            headers: {
                Authorization: token
            }
        })
        const {status, message} = res.data

        console.log(status);
        if(status === 1)
        {
            toast.success(" Destino creado correctamente. ")
            dispatch({type: CREATE_DESTINOS_SUCCESS})
            dispatch(getDestinos())
        }
        else if(status === 2)
        dispatch({type: LOGOUT})
        else { toast.error("Error creando destino. "+message)
            dispatch({type: CREATE_DESTINOS_ERROR})
        }
    } catch (error) {
        dispatch({type: CREATE_DESTINOS_ERROR})
    }
}

export const updateDestinos = (id, obj)=>async(dispatch)=>{    

    const {token} = store.getState().userReducer
    dispatch({type: UPDATE_DESTINOS_LOADING})
    try {
        const res = await axios(BASE_URL+"/destino/", {
            method: "patch",
            data: obj,
            headers: {
                Authorization: token,
                id: id
            }
        })
        const {status, message} = res.data
        if(status=== 1)
        {
            toast.success(" Destino modificado correctamente. ")
            dispatch({type: UPDATE_DESTINOS_SUCCESS})
            dispatch(getDestinos())
        }
        else if(status === 2)
        dispatch({type: LOGOUT})
        else { toast.error(" Error actualizando destino. "+message)
            dispatch({type: UPDATE_DESTINOS_ERROR})
        }
    } catch (error) {
        dispatch({type: UPDATE_DESTINOS_ERROR})
    }
}

export const deleteDestinos = (id)=>async(dispatch)=>{
   
    
    const {token} = store.getState().userReducer
    dispatch({type: DELETE_DESTINOS_LOADING})
    try {
        const res = await axios(BASE_URL+"/destino/", {
            method: "delete",
            headers: {
                Authorization: token,
                id: id
            }
        })
        console.log(" data delete => ",res.data);
        
        const {status, message} = res.data
        if(status === 1)
        {
            dispatch({type: DELETE_DESTINOS_SUCCESS})
            dispatch(getDestinos())
        }
        else if(status === 2)
        dispatch({type: LOGOUT})
        else { toast.error(" Error borrando destino. "+message)
            dispatch({type: DELETE_DESTINOS_ERROR})
        }
    } catch (error) {
        dispatch({type: DELETE_DESTINOS_ERROR})
    }
}